import React from 'react'
import { ErrorHeader } from '@components/errorHeader/errorHeader'
import { SocialNetworksList } from '@components'

interface ErrorSectionProps {
    errorTitle?: string
    errorMessage?: string
    errorContact?: string
    imageUrl?: string
    imageAlt?: string
}

const ErrorSection = React.forwardRef<HTMLDivElement, ErrorSectionProps>(
    ({ errorTitle, errorMessage, errorContact, imageUrl, imageAlt }, ref) => (
        <div
            ref={ref}
            tabIndex={-1}
            className="place-self-center max-w-screen-xl mx-auto"
        >
            <ErrorHeader
                title={errorTitle}
                description={`<p>${errorMessage}${
                    errorContact
                        ? `<a class='text-primary-500 font-semibold underline' href='mailto:${errorContact}'>${errorContact}</a>`
                        : ''
                }</p>`}
                imageUrl={imageUrl}
                imageAlt={imageAlt}
            />
            <SocialNetworksList />
        </div>
    )
)

ErrorSection.displayName = 'ErrorSection'

export default ErrorSection
